import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import Loading from 'components/Loading';
import messages from './messages';
import EditNotificationForm from './EditNotificationForm';

class UpdateNotification extends React.Component {
  static propTypes = {
    updateNotification: PropTypes.func.isRequired,
    fetchNotification: PropTypes.shape({
      loading: PropTypes.bool,
      notification: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        message: PropTypes.string,
        datetime_from: PropTypes.string,
        datetime_to: PropTypes.string,
        priority: PropTypes.string,
        creator: PropTypes.string,
        created_at: PropTypes.string,
        updated_at: PropTypes.string,
      }),
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(formValues) {
    const notification = {
      id: this.props.match.params.id,
      title: formValues.title,
      message: formValues.message,
      priority: formValues.priority.value,
      datetime_from: moment(
        `${formValues.startDate} ${formValues.startTime.value}`,
        'DD.MM.YYYY HH:mm',
      ),
      datetime_to: moment(
        `${formValues.endDate} ${formValues.endTime.value}`,
        'DD.MM.YYYY HH:mm',
      ),
    };
    await this.props.updateNotification(notification);
    this.props.history.push({ pathname: '/admin/notifications' });
  }

  render() {
    const { fetchNotification } = this.props;

    if (fetchNotification.loading) {
      return <Loading />;
    }

    if (!fetchNotification.notification) {
      return (
        <div>
          <FormattedMessage {...messages.notFound} />
        </div>
      );
    }

    const { notification } = fetchNotification;

    const initialValues = {
      title: notification.title,
      message: notification.message,
      priority: { value: notification.priority, label: notification.priority },
      startDate: moment(notification.datetime_from).format('DD.MM.YYYY'),
      startTime: moment(notification.datetime_from).format('HH:mm'),
      endDate: moment(notification.datetime_to).format('DD.MM.YYYY'),
      endTime: moment(notification.datetime_to).format('HH:mm'),
    };

    return (
      <div>
        <h2>
          <FormattedMessage {...messages.editHeading} />
        </h2>
        <EditNotificationForm
          onSubmit={this.handleSubmit}
          errors={this.state.errors}
          initialValues={initialValues}
        />
      </div>
    );
  }
}

const fetchNotificationQuery = gql`
  query fetchNotification($id: ID!) {
    notification(id: $id) {
      id
      title
      message
      datetime_from
      datetime_to
      priority
      created_at
      updated_at
    }
  }
`;

const updateNotificationMutation = gql`
  mutation updateNotificationMutation($patch: NotificationInput!) {
    updateNotification(patch: $patch) {
      id
      title
      message
      datetime_from
      datetime_to
      priority
      created_at
      updated_at
    }
  }
`;

export default compose(
  injectIntl,
  graphql(fetchNotificationQuery, {
    name: 'fetchNotification',
    options: props => ({
      variables: { id: props.match.params.id },
    }),
  }),
  graphql(updateNotificationMutation, {
    props: ({ mutate }) => ({
      updateNotification: notification =>
        mutate({
          variables: { patch: notification },
        }),
    }),
  }),
  connect(),
)(UpdateNotification);
